var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("price-combination-result", {
        ref: "priceCombinationResult",
        attrs: {
          "trunk-line-enable": _vm.trunkLineEnable,
          "pre-port-enable": _vm.prePortEnable,
          "last-mile-enable": _vm.lastMileEnable,
          "trunk-line-data": _vm.trunkLineData,
          "pre-port-data": _vm.prePortData,
          "last-mile-data": _vm.lastMileData,
          "trunk-line-data-total": _vm.trunkLineDataTotal,
          "pre-port-data-total": _vm.prePortDataTotal,
          "last-mile-data-total": _vm.lastMileDataTotal
        },
        on: {
          pagination: function(p) {
            return _vm.$emit("pagination", p)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }